import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";

export const GTMOnProcessSttEvent = (eventName: string, custom = {}) => {
  dataLayer(eventName, custom, ["timestamp", "userType", "userId"]);
};
